export default [
  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },  
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: { template: '<router-view/>' },
    // component: () => import(
    //   `@/pages/NotFound.vue`
    // )
  },
  {
    path: '/login',
    meta: {
      public: true,
    },
    name: 'Login',
    component: () => import(
      `@/pages/Login.vue`
    )
  },
  {
    path: '/',
    meta: { },
    name: 'Root',
    redirect: {
      name: 'Login'
    }
  },
  {
    path: '/dashboard',
    meta: { breadcrumb: true, name: 'Dashboard' },
    name: 'Dashboard',
    component: () => import(
      `@/pages/Dashboard.vue`
    )
  },
  {
    path: '/meus-dados',
    meta: { breadcrumb: true, name: 'Meus Dados' },
    name: 'MeusDados',
    component: () => import(
      `@/pages/MeusDados.vue`
    )
  },
  {
    path: '/banners',
    name: 'Banners',
    component: { template: '<router-view/>' },
    redirect: {
      path: '/banners'
    },
    children: [
      {
        path: '/banners',
        name: 'BannersLista',
        meta: { breadcrumb: true, name: 'Banners', },
        component: () => import(
          `@/pages/banners/Lista.vue`
        ),
      },
      {
        path: '/banners/cadastro',
        name: 'BannersCadastro',
        meta: { breadcrumb: true, name: 'Cadastro' },
        component: () => import(
          `@/pages/banners/Cadastro.vue`
        ),
      },
      {
        path: '/banners/cadastro/:id',
        name: 'BannersEditar',
        meta: { breadcrumb: true, name: 'Editar' },
        component: () => import(
          `@/pages/banners/Cadastro.vue`
        ),
      },
    ]
  },
  {
    path: '/cidades',
    name: 'Cidades',
    component: { template: '<router-view/>' },
    redirect: {
      path: '/cidades'
    },
    children: [
      {
        path: '/cidades',
        name: 'CidadesLista',
        meta: { breadcrumb: true, name: 'Cidades', },
        component: () => import(
          `@/pages/cidades/Lista.vue`
        ),
      },
      {
        path: '/cidades/cadastro',
        name: 'CidadesCadastro',
        meta: { breadcrumb: true, name: 'Cadastro' },
        component: () => import(
          `@/pages/cidades/Cadastro.vue`
        ),
      },
      {
        path: '/cidades/cadastro/:id',
        name: 'CidadesEditar',
        meta: { breadcrumb: true, name: 'Editar' },
        component: () => import(
          `@/pages/cidades/Cadastro.vue`
        ),
      },
    ]
  },
  {
    path: '/imoveis',
    name: 'Imoveis',
    component: { template: '<router-view/>' },
    redirect: {
      path: '/imoveis'
    },
    children: [
      {
        path: '/imoveis',
        name: 'ImoveisLista',
        meta: { breadcrumb: true, name: 'Imóveis', },
        component: () => import(
          `@/pages/imoveis/Lista.vue`
        ),
      },
      {
        path: '/imoveis/cadastro',
        name: 'ImoveisCadastro',
        meta: { breadcrumb: true, name: 'Cadastro' },
        component: () => import(
          `@/pages/imoveis/Cadastro.vue`
        ),
      },
      {
        path: '/imoveis/cadastro/:id',
        name: 'ImoveisEditar',
        meta: { breadcrumb: true, name: 'Editar' },
        component: () => import(
          `@/pages/imoveis/Cadastro.vue`
        ),
      },
    ]
  },
  {
    path: '/sliders',
    name: 'SlidersTV',
    component: { template: '<router-view/>' },
    redirect: {
      path: '/sliders'
    },
    children: [
      {
        path: '/sliders',
        name: 'SlidersLista',
        meta: { breadcrumb: true, name: 'Sliders TV', },
        component: () => import(
          `@/pages/sliders/Lista.vue`
        ),
      },
      {
        path: '/sliders/cadastro',
        name: 'SlidersCadastro',
        meta: { breadcrumb: true, name: 'Cadastro' },
        component: () => import(
          `@/pages/sliders/Cadastro.vue`
        ),
      },
      {
        path: '/sliders/cadastro/:id',
        name: 'SlidersEditar',
        meta: { breadcrumb: true, name: 'Editar' },
        component: () => import(
          `@/pages/sliders/Cadastro.vue`
        ),
      },
    ]
  },
  {
    path: '/tipos-imoveis',
    name: 'TiposImoveis',
    component: { template: '<router-view/>' },
    redirect: {
      path: '/tipos-imoveis'
    },
    children: [
      {
        path: '/tipos-imoveis',
        name: 'TiposImoveisLista',
        meta: { breadcrumb: true, name: 'Tipos de imóveis', },
        component: () => import(
          `@/pages/tipos-imoveis/Lista.vue`
        ),
      },
      {
        path: '/tipos-imoveis/cadastro',
        name: 'TiposImoveisCadastro',
        meta: { breadcrumb: true, name: 'Cadastro' },
        component: () => import(
          `@/pages/tipos-imoveis/Cadastro.vue`
        ),
      },
      {
        path: '/tipos-imoveis/cadastro/:id',
        name: 'TiposImoveisEditar',
        meta: { breadcrumb: true, name: 'Editar' },
        component: () => import(
          `@/pages/tipos-imoveis/Cadastro.vue`
        ),
      },
    ]
  },
  {
    path: '/usuarios',
    name: 'Usuarios',
    component: { template: '<router-view/>' },
    redirect: {
      path: '/usuarios'
    },
    children: [
      {
        path: '/usuarios',
        name: 'UsuariosLista',
        meta: { breadcrumb: true, name: 'Usuários', },
        component: () => import(
          `@/pages/usuarios/Lista.vue`
        ),
      },
      {
        path: '/usuarios/cadastro',
        name: 'UsuariosCadastro',
        meta: { breadcrumb: true, name: 'Cadastro' },
        component: () => import(
          `@/pages/usuarios/Cadastro.vue`
        ),
      },
      {
        path: '/usuarios/cadastro/:id',
        name: 'UsuariosEditar',
        meta: { breadcrumb: true, name: 'Editar' },
        component: () => import(
          `@/pages/usuarios/Cadastro.vue`
        ),
      },
    ]
  }
];


// WEBPACK FOOTER //
// ./src/router/paths.js